import React from "react";
import { NavLink } from "react-router-dom";

type SidebarNavItemProps = {
  label: string;
  to: string;
};

export default function SidebarNavItem({ label, to }: SidebarNavItemProps) {
  return (
    <NavLink
      to={to}
      end={to === to.replace(/\/$/, "")}
      className={({ isActive }) =>
        [
          "block rounded-xl px-3 py-2 text-sm font-bold transition",
          isActive
            ? "bg-brand-vault text-white shadow-sm"
            : "text-slate-700 hover:bg-slate-100",
        ].join(" ")
      }
    >
      {label}
    </NavLink>
  );
}